import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

import "./assets/styles/global.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "quill/dist/quill.snow.css";
import "bootstrap";
import "material-symbols";
import Notifications from "@kyvg/vue3-notification";

import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBXKKTMOSOBp0LwPs_kgYTJMOKz7nnGsbU",
  authDomain: "ruderclub-speck-weg.firebaseapp.com",
  projectId: "ruderclub-speck-weg",
  storageBucket: "ruderclub-speck-weg.firebasestorage.app",
  messagingSenderId: "188524277486",
  appId: "1:188524277486:web:8ecb1f7726d3bfc0318dff",
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);
const firebaseDb = getFirestore(firebaseApp);
export { firebaseAuth, firebaseDb };

let appInitialized = false;

onAuthStateChanged(firebaseAuth, () => {
  if (!appInitialized) {
    appInitialized = true;

    createApp(App).use(router).use(Notifications).mount("#app");
  }
});
